module.exports = __webpack_public_path__ + "img/1-en.af98181b.jpg";